module.exports = __webpack_public_path__ + "img/phone.5ef4edbd.svg";